import { render, staticRenderFns } from "./PhotoCapture.vue?vue&type=template&id=a3b44402&"
import script from "./PhotoCapture.vue?vue&type=script&lang=js&"
export * from "./PhotoCapture.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports